import { useState } from 'react';
import { Box } from '@mui/material';
import { CxSpendHeader } from './CxSpendHeader';
import { SpendAmountInput } from './SpendAmountInput';
import { monthlySpendError } from './currentSupplierLimits';

const REQUIRED =
  "Required — enter the client's current monthly CX spend, or add current suppliers to fill it automatically.";

export interface TypedCxSpendProps {
  typed: number | null;
  canEdit: boolean;
  onType: (amount: number | null) => void;
}

/** The current spend as the Advisor types it, while Current Suppliers has nothing to fill it with. */
export const TypedCxSpend = ({ typed, canEdit, onType }: TypedCxSpendProps) => {
  const [text, setText] = useState(typed === null ? '' : String(typed));
  const error = monthlySpendError(text);
  const required = canEdit && text.trim() === '' ? REQUIRED : null;

  const save = () => {
    if (error) return;
    onType(text.trim() === '' ? null : Number(text));
  };

  return (
    <Box className="flex flex-col gap-1">
      <CxSpendHeader />
      <SpendAmountInput
        text={text}
        error={error ?? required}
        disabled={!canEdit}
        onChange={setText}
        onBlur={save}
      />
    </Box>
  );
};
